import * as React from "react";

const SvgIcnCloseLarge = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M17.392 7.825L13.216 12l4.176 4.175a.86.86 0 11-1.216 1.216L12 13.217l-4.175 4.176a.86.86 0 01-1.216-1.216L10.783 12 6.608 7.825a.86.86 0 011.216-1.216L12 10.783l4.175-4.176a.86.86 0 111.216 1.216z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnCloseLarge;
